<template>
  <div class="app">
	<meta name="referrer" content="no-referrer">
    <router-view></router-view>
  </div>
</template>
<script>
	import localStore from './localStorage/localStorage.js'
	export default {
		data(){
			return{
				
			}
		},
		watch:{
		      items:{
		         handler:function(items){
		         localStore.save(items)   
		      },
		        deep:true
		      }
		  }
	}

</script>
<style>
	@import url("../common/zcm-main.css");
  * {
    padding: 0;
    margin: 0;
    list-style: none;
  }
</style>